import { createContext, memo, type ReactNode, useContext } from 'react';

export type PlayerTransportController = {
  beginSeek: () => void;
  endSeek: () => void;
  pause: () => void;
  play: () => void;
  playing: boolean;
  seek: (currentTime: number) => void;
};

// Absence deliberately keeps the player's native transport behavior.
const PlayerTransportContext = createContext<PlayerTransportController | null>(null);

export type PlayerTransportProviderProps = {
  children: ReactNode;
  controller: PlayerTransportController | null;
};

export const PlayerTransportProvider = memo(({ children, controller }: PlayerTransportProviderProps) => (
  <PlayerTransportContext.Provider value={controller}>{children}</PlayerTransportContext.Provider>
));

PlayerTransportProvider.displayName = 'PlayerTransportProvider';

export const usePlayerTransportController = () => ({ transportController: useContext(PlayerTransportContext) });
